<template>
    <div @click.stop="showPopOutP($event)" id="HomeList" style="display: flex; flex-direction: column; margin-left: 20px">
        <div>
            <div class="btn-fold">
                <el-button type="primary" class="btn-color" @click="short == false ? (short = true) : (short = false)">{{
                    short ? '非简版' : '简版'
                }}</el-button>
                <el-button
                    type="primary"
                    class="btn-color"
                    @click="direction == 'vertical' ? (direction = 'horizontal') : (direction = 'vertical')"
                    >{{ direction == 'vertical' ? '横向' : '竖向' }}</el-button
                >
                <el-button type="primary" class="btn-color" @click="expandAllFalse">全部折叠</el-button>
                <el-button type="primary" class="btn-color" @click="expandAllTrue">全部展开</el-button>
            </div>
            <el-select clearable filterable v-model="department_rid" placeholder="请选择部门" class="btn" size="mini">
                <el-option v-for="item in departmentOptions" :key="item.rid" :label="item.name + '-' + item.code" :value="item.rid">
                </el-option>
            </el-select>
            <el-select clearable filterable v-model="rank_elt" placeholder="请选择等级" class="btn" size="mini">
                <el-option v-for="item in rankOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
            </el-select>
            <el-button type="primary" @click="getList" class="btn btn-color" style="width: 70px">搜索</el-button>
        </div>
        <TreeList v-if="data2.length > 0" :data2="data2" :short="short" :key="direction" :direction="direction" ref="treeList"></TreeList>
    </div>
</template>

<script>
import TreeList from './tree.vue';
export default {
    name: 'organization',
    components: {
        TreeList
    },
    data() {
        return {
            // 简版
            short: false,
            // 横竖向
            direction: 'horizontal',
            data: {},
            data2: [],
            rank_elt: '',
            department_rid: '',
            departmentOptions: [],
            rankOptions: [],
            key: ''
        };
    },
    beforeMount() {
        this.key = this.$route.query.token;
    },
    mounted() {
        this.$nextTick(() => {
            this.getList();
            this.remoteDepartment();
            this.getRank();
        });
    },
    methods: {
        //获取职位等级
        getRank() {
            let params = {};
            this.$api
                .decisionRank(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.rankOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //部门下拉方法
        remoteDepartment() {
            let params = {};
            this.$api
                .budgetDepartment(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        showPopOutP(e) {
            this.$refs.treeList.showPopOutP();
        },
        expandAllFalse() {
            this.$refs.treeList.expandAllFalse();
        },
        expandAllTrue() {
            this.$refs.treeList.expandAllTrue();
        },
        getList() {
            let params = {
                department_rid: this.department_rid,
                rank_elt: this.rank_elt,
                key: this.key
            };

            this.$api
                .organizeLists(params)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data != []) {
                            if (!res.data.persons_enable) {
                                res.data.persons_enable = [];
                            }
                            var result = [];
                            result.push(res.data);
                            result = JSON.parse(JSON.stringify(result).replaceAll(/name/g, 'label'));
                            this.data2 = result;
                        }
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>

<style lang="scss" scoped>
#HomeList {
    width: auto;
    height: 100%;
    overflow-y: scroll;
}

.organizationtest {
    float: left;
    width: 100%;
    height: 100%;
    margin: 20px 0px 0px 0;
    padding-bottom: 20px;
}

.btn-fold {
    width: 100%;
}

.btn-fold .el-button {
    float: left;
    margin: 5px;
}

.btn {
    float: left;
    margin: 6px;
    border: none;
    font-size: 13px;
}

.el-select {
    color: #f7f7fc;
    background: #fff;
    border-radius: 5px;
    border-color: #7f7f80;
}

.el-select:hover {
    color: #f7f7fc;
    border-color: #fff;
    background: #7f7f80;
}
.btn-color {
    background: gray;
}
</style>
